import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useTradicionalGroupsChartsDataContext } from './hooks/useTradicionalGroupsChartsDataContext';

export const FamiliesPerQuilombolaComunity = () => {
    const { chartData } = useTradicionalGroupsChartsDataContext();

    return (
        <SimpleBars
            title={'Total de Famílias por Comunidade Quilombola'}
            horizontal={false}
            subtitles={chartData?.familiesPerQuilombolaComunity?.map(
                (item) => item.description
            )}
            values={chartData?.familiesPerQuilombolaComunity?.map(
                (item) => item.total || 0
            )}
        />
    );
};
